<script setup lang="ts">
import phoneMockup from "/product/phone-mockup.webp";
//import { Button } from "@/components/ui/button";
import appleLogo from "/logos/svg/apple-logo.svg";
//import googlePlay from "/logos/svg/google-play.svg";
//import { ref } from "vue";
import { motion } from "motion-v";

//const sectionRef = ref<HTMLElement | null>(null);

/*const { scrollYProgress } = useScroll({
  target: sectionRef,
  offset: ["start end", "end start"],
});*/

//const translateY = useTransform(scrollYProgress, [0, 1], [50, -50]);

</script>

<template>
  <section ref="sectionRef" class="relative isolate">
    <!-- Big headline -->
    <div class="flex justify-center items-center">
      <h1
        class="text-5xl md:text-7xl lg:text-[96px] font-extrabold leading-[0.9] text-center tracking-tight text-white"
      >
        Stay connected <br />
        where you travel
      </h1>
    </div>

    <div class="mt-6">
      <div class="relative mx-auto max-w-6xl px-4 md:px-8">
        <div
          class="relative h-[360px] rounded-3xl bg-blue-500 shadow-[inset_4px_4px_8px_rgba(0,0,0,0.4),inset_-4px_-4px_8px_rgba(0,0,0,0.4)] flex items-center justify-center"
          :style="{
            backgroundImage:
              'radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.15) 1px, transparent 0)',
            backgroundSize: '10px 10px',
            imageRendering: 'pixelated',
          }"
        >
          <!-- Phone mockup -->
          <motion.img
            :src="phoneMockup"
            alt="App mockup"
            class="absolute md:-bottom-20 lg:-bottom-25 -right-10 z-20 scale-85 pointer-events-none hidden md:block"
            loading="lazy"
            
          />
          <img src="https://cdn.jittr.app/logos/logo-white.png" alt="logo" class="z-0 relative mb-8 block md:hidden" />

          <!-- Bottom content -->
          <div class="absolute bottom-0 left-0 right-0 p-6">
            <p
              class="text-2xl md:text-4xl font-semibold tracking-tight text-white md:max-w-xs lg:max-w-sm"
            >
              Download App
            </p>
            <div class="flex flex-wrap gap-4 py-2 relative z-30">
              <a
                href="https://apps.apple.com/us/app/jittr-esim-global-data/id6753299070"
                class="transition-all duration-300 ease-out hover:scale-102 hover:shadow-xl hover:brightness-110 active:scale-100 shadow-[inset_4px_4px_8px_rgba(0,0,0,0.1),inset_-4px_-4px_8px_rgba(0,0,0,0.1)] cursor-pointer bg-white text-black rounded-lg flex items-center gap-2 px-4 py-2"
              >
                <img :src="appleLogo" alt="apple-logo" class="w-6 h-6" />
                App Store
              </a>
              
              <!--
              <Button
                class="transition-all duration-300 ease-out hover:scale-102 hover:shadow-xl hover:brightness-110 active:scale-100 shadow-[inset_4px_4px_8px_rgba(0,0,0,0.1),inset_-4px_-4px_8px_rgba(0,0,0,0.1)] cursor-pointer"
              >
                <img :src="googlePlay" alt="google-play-logo" class="w-6 h-6" />
                Google Play
              </Button>
              -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
